export default "__VITE_ASSET__fSTfg8Th__"